import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs/Observable';
import { NavCreateElement2Component } from '../compv/nav-create-element2/nav-create-element2';
import { INavElementsNode } from '../model/nav-elements-nodegroup';
import { INavNewEdgeAndElement } from '../model/nav-new-edge-element.interface';

@Injectable()
export class CreateElementService {

   constructor(private dialog: MatDialog) { }

   public open(
      title: string,
      subtitle: string,
      selectedNode: INavElementsNode
   ): Observable<INavNewEdgeAndElement> {

      let dialogRef: MatDialogRef<NavCreateElement2Component>;

      dialogRef = this.dialog.open(NavCreateElement2Component, {
         minWidth: '25%',
      });
      dialogRef.componentInstance.title = 'Neues Element';
      dialogRef.componentInstance.subtitle = 'Bei der Suche wird nach Elementen aktivierter Beziehungs-Typen gefiltert';
      dialogRef.componentInstance.cancelButtonText = 'ABBRECHEN';
      dialogRef.componentInstance.okButtonText = 'SCHLIESSEN';
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.subtitle = subtitle;
      dialogRef.componentInstance.selectedNode = selectedNode;

      dialogRef.componentInstance.updateView();

      return dialogRef.afterClosed();
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/service/create-element.service.ts